import React, { useState, useEffect } from 'react';
import { getHistoryGrouped, getHistoryDetail } from '../api/api';

const History = () => {
  const [groupedList, setGroupedList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState({ eaname: '', broker: '', login: '' });
  const [expandedRow, setExpandedRow] = useState(null); // 펼쳐진 행
  const [detailList, setDetailList] = useState([]); // 상세 기록
  const [detailLoading, setDetailLoading] = useState(false);
  const size = 20;

  const fetchData = async (pageNum) => {
    try {
      const res = await getHistoryGrouped({ ...search, page: pageNum, size });
      setGroupedList(res.data.list || []);
      setTotal(res.data.total || 0);
      setPage(pageNum);
      setExpandedRow(null);
      setDetailList([]);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  const handleSearch = () => {
    fetchData(1);
  };

  const handleReset = () => {
    setSearch({ eaname: '', broker: '', login: '' });
    setTimeout(() => fetchData(1), 100);
  };

  // 행 클릭 - 상세 기록 토글
  const handleRowClick = async (item) => {
    const rowKey = `${item.eaname}-${item.login}`;
    
    if (expandedRow === rowKey) {
      // 이미 펼쳐진 행 클릭 → 닫기
      setExpandedRow(null);
      setDetailList([]);
      return;
    }

    // 새로운 행 펼치기 → 상세 기록 로드
    setExpandedRow(rowKey);
    setDetailLoading(true);
    
    try {
      const res = await getHistoryDetail({ eaname: item.eaname, login: item.login });
      setDetailList(res.data.list || []);
    } catch (err) {
      console.error(err);
      setDetailList([]);
    }
    setDetailLoading(false);
  };

  const totalPages = Math.ceil(total / size);

  return (
    <div>
      {/* Filter Bar - EA 목록 스타일 */}
      <div className="table-container" style={{ marginBottom: '24px' }}>
        <div className="filters-bar">
          <div className="filter-item">
            <label>Login</label>
            <input
              type="text"
              value={search.login}
              onChange={(e) => setSearch({ ...search, login: e.target.value })}
              placeholder="계좌번호"
            />
          </div>

          <div className="filter-item">
            <label>Broker</label>
            <input
              type="text"
              value={search.broker}
              onChange={(e) => setSearch({ ...search, broker: e.target.value })}
              placeholder="전체"
            />
          </div>

          <div className="filter-item">
            <label>EA명</label>
            <input
              type="text"
              value={search.eaname}
              onChange={(e) => setSearch({ ...search, eaname: e.target.value })}
              placeholder="전체"
            />
          </div>

          <div className="filter-buttons">
            <button className="btn btn-primary" onClick={handleSearch}>
              🔍 검색
            </button>
            <button className="btn btn-secondary" onClick={handleReset}>
              초기화
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="table-container">
        <div className="table-header">
          <h2>
            📋 EA 접속 기록 ({total}건)
            <button 
              className="btn btn-secondary btn-sm"
              style={{ marginLeft: '12px' }}
              onClick={() => fetchData(page)}
            >
              ↻ 새로고침
            </button>
          </h2>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>EA명</th>
                <th>LOGIN</th>
                <th>BROKER</th>
                <th>TRADER</th>
                <th>TYPE</th>
                <th>계좌</th>
                <th>접속횟수</th>
                <th>마지막 접속</th>
              </tr>
            </thead>
            <tbody>
              {groupedList.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center', padding: '40px', color: '#64748B' }}>
                    데이터가 없습니다.
                  </td>
                </tr>
              ) : (
                groupedList.map((item) => {
                  const rowKey = `${item.eaname}-${item.login}`;
                  const isExpanded = expandedRow === rowKey;
                  
                  return (
                    <React.Fragment key={rowKey}>
                      {/* 그룹 행 */}
                      <tr 
                        onClick={() => handleRowClick(item)}
                        style={{ cursor: 'pointer', backgroundColor: isExpanded ? '#F0F9FF' : 'inherit' }}
                      >
                        <td style={{ textAlign: 'center', color: '#4F46E5' }}>
                          {isExpanded ? '▼' : '▶'}
                        </td>
                        <td><strong>{item.eaname}</strong></td>
                        <td>{item.login}</td>
                        <td style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {item.broker}
                        </td>
                        <td>{item.tradername || '-'}</td>
                        <td>{item.metatype || '-'}</td>
                        <td>{item.accounttype || '-'}</td>
                        <td>
                          <span style={{ 
                            background: '#EEF2FF', 
                            color: '#4F46E5', 
                            padding: '4px 12px', 
                            borderRadius: '12px',
                            fontWeight: '600'
                          }}>
                            {item.accesscount}회
                          </span>
                        </td>
                        <td>{item.lastaccessdate?.substring(0, 19) || '-'}</td>
                      </tr>

                      {/* 상세 기록 (펼쳐진 경우) */}
                      {isExpanded && (
                        <tr>
                          <td colSpan="9" style={{ padding: 0, backgroundColor: '#F8FAFC' }}>
                            <div style={{ padding: '16px 24px 16px 48px' }}>
                              <h4 style={{ marginBottom: '12px', color: '#475569' }}>
                                📜 상세 접속 기록
                              </h4>
                              {detailLoading ? (
                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                  <div className="spinner" style={{ width: '24px', height: '24px' }}></div>
                                </div>
                              ) : detailList.length === 0 ? (
                                <p style={{ color: '#94A3B8' }}>상세 기록이 없습니다.</p>
                              ) : (
                                <table style={{ width: '100%', fontSize: '13px' }}>
                                  <thead>
                                    <tr style={{ backgroundColor: '#E2E8F0' }}>
                                      <th style={{ padding: '8px 12px', textAlign: 'left' }}>NO</th>
                                      <th style={{ padding: '8px 12px', textAlign: 'left' }}>IP ADDRESS</th>
                                      <th style={{ padding: '8px 12px', textAlign: 'left' }}>ACCESS DATE</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {detailList.map((detail, idx) => (
                                      <tr key={detail.historyseq} style={{ backgroundColor: idx % 2 === 0 ? '#FFFFFF' : '#F8FAFC' }}>
                                        <td style={{ padding: '8px 12px' }}>{idx + 1}</td>
                                        <td style={{ padding: '8px 12px' }}>{detail.ipaddr || '-'}</td>
                                        <td style={{ padding: '8px 12px' }}>{detail.credate?.substring(0, 19) || '-'}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            <button onClick={() => fetchData(1)} disabled={page === 1}>«</button>
            <button onClick={() => fetchData(page - 1)} disabled={page === 1}>‹</button>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5 || page <= 3) {
                pageNum = i + 1;
              } else if (page >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = page - 2 + i;
              }
              return (
                <button
                  key={pageNum}
                  className={page === pageNum ? 'active' : ''}
                  onClick={() => fetchData(pageNum)}
                >
                  {pageNum}
                </button>
              );
            })}
            <button onClick={() => fetchData(page + 1)} disabled={page === totalPages}>›</button>
            <button onClick={() => fetchData(totalPages)} disabled={page === totalPages}>»</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default History;
